<div class="pcs-container">
  <div class="pcs-header">
    <h3 class="pcs-title">Consultants</h3>
  </div>

  <div class="pro-card column">
    @if (isLoading) {
      <p class="text-muted">Loading...</p>
    }

    @if (!isLoading && consultantGroups.length === 0) {
      <div class="empty-state">
        <p class="text-muted">No consultants assigned</p>
      </div>
    }

    @if (!isLoading && consultantGroups.length > 0) {
      <div class="consultant-groups">
        @for (group of consultantGroups; track group.consultantOrgId) {
          <div class="consultant-group">
            <div class="group-header" (click)="toggleGroup(group.consultantOrgId)">
              <span class="group-name">{{ group.consultantOrgName }}</span>
              <mat-icon>{{ isExpanded(group.consultantOrgId) ? 'expand_less' : 'expand_more' }}</mat-icon>
            </div>
            @if (isExpanded(group.consultantOrgId)) {
              <div class="group-consultants">
                @for (consultant of group.consultants; track consultant.id) {
                  <div class="consultant-item">
                    <span class="consultant-name">{{ consultant.firstName }} {{ consultant.lastName }}</span>
                    <span class="consultant-email">{{ consultant.email }}</span>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
